import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "getINCOMINGREQUESTSTableStructure";
export const UPDATE_TABLE_DATA = "getINCOMINGREQUESTSTableData";
// export const EXPORT_TABLE_DATA = "exportINCOMINGREQUESTSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINCOMINGREQUESTSTableStructure";
export const SET_TABLE_DATA = "setINCOMINGREQUESTSTableData";
export const SET_TABLE_FILTER = "setINCOMINGREQUESTSTableFilter";
export const SET_TABLE_PAGE = "setINCOMINGREQUESTSTablePage";
export const SET_TABLE_PERPAGE = "setINCOMINGREQUESTSTablePerPage";
export const SET_TABLE_SORTBY = "setINCOMINGREQUESTSTableSortBy";
export const SET_TABLE_SORTORDER = "setINCOMINGREQUESTSTableSortOrder";
// export const SET_EXPORT_LINK = "setINCOMINGREQUESTSExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getINCOMINGREQUESTSTableState(state) {
    return state.table_state;
  },

  getINCOMINGREQUESTSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getINCOMINGREQUESTSTableFilters(state) {
    return state.table_structure.filters;
  },

  getINCOMINGREQUESTSTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getINCOMINGREQUESTSTableData(state) {
    return state.table_data.data;
  },

  getINCOMINGREQUESTSTableProperties(state) {
    return state.table_structure.properties;
  },

  getINCOMINGREQUESTSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/datahub/incoming_requests")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          resolve(data);
        })
        .finally(() => {
          context.commit(SET_PAGE_LOADING, false);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    // context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/incoming_requests/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  // [EXPORT_TABLE_DATA](context, payload) {
  //   context.commit(SET_PAGE_LOADING, true);
  //   return new Promise((resolve) => {
  //     ApiService.post("/datahub/messagesNew/export", payload)
  //       .then(({ data }) => {
  //         // console.log("export data is ", data);
  //         context.commit(SET_EXPORT_LINK, data.url);
  //         resolve(data);
  //       })
  //       .catch((data) => {
  //         context.commit(SET_PAGE_LOADING, false);
  //         resolve(data);
  //       });
  //   });
  // },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  // [SET_EXPORT_LINK](state, link) {
  //   state.export_link = link;
  // },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
